<template>
  <div class="synthese__container">
    <SyntheseSection
      title="L'employeur"
      :items="employerDetails"
    />

    <SyntheseSection
      title="Prestation"
      :items="prestationDetails"
    />

    <SyntheseSection
      title="Chiffrage (montants HT)"
      :items="chiffrageDetails"
    />
  </div>
  <FormContainer>
    <template #content>
      <WrapperCheckbox
        id="field_unknown1"
        v-model="attestationSurHonneurModel"
        :alertLabel="meta.attestationSurHonneur?.$messageErreurDirty!"
        label="J’atteste sur l’honneur l’exactitude des données saisies."
        :readonly
        :required="meta.attestationSurHonneur?.$status === PropertyStatus.Required"
        class="col-36"
      />
      <WrapperCheckbox
        id="field_unknown2"
        v-model="acceptationCgModel"
        :alertLabel="meta.acceptationCg?.$messageErreurDirty!"
        :readonly
        :required="meta.acceptationCg?.$status === PropertyStatus.Required"
        class="col-36"
      >
        <BasicText style="flex: 1">
          J'accepte les Conditions Générales (CG) d'Akto et les conditions de prise en charge, et je confirme avoir pris
          connaissance de celles-ci via le lien suivant : «
          <BasicLink
            label="Conditions générales - Akto"
            @link-click="redirectExterne('https://www.akto.fr/conditions-generales')"
          />
        </BasicText>
        »
      </WrapperCheckbox>
      <WrapperInput
        id="field_unknown"
        v-model="commentaireModel"
        label="Commentaires (infos complémentaires...)"
        :required="meta.commentaire?.$status === PropertyStatus.Required"
        :alertLabel="meta.commentaire?.$messageErreurDirty!"
        class="col-36"
        deletable
        hint="256 caractères maximum"
        :maxlength="256"
        :readonly
      />
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status'
import { SousDispositifLibelle } from '@/features/domaine/types/opco/Demande/OUTILFPE'
import { useDemandeOutilFPEStore } from '@/features/interface/demande/outilfpe/useDemandeOutilFPEStore.ts'
import { FormContainer, SyntheseSection } from '@/features/interface/demande/shared'
import { formatNumber, redirectExterne } from '@/features/shared/tools'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

  const store = useDemandeOutilFPEStore()
  const { model } = useDemandeOutilFPEStore()
  const { setupFieldWithKey } = useDemandeOutilFPEStore()
  const { meta, readonly } = storeToRefs(store)
  //const getDateIntitule = (value: any) => (isDate(value) ? dateFormatter(value) : '')
  const idcc = model?.employeur?.etablissement?.idcc?.code ?? ''

  const commentaireModel = setupFieldWithKey<string>('commentaire', true)
  const attestationSurHonneurModel = setupFieldWithKey<boolean>('attestationSurHonneur', true)
  const acceptationCgModel = setupFieldWithKey<boolean>('acceptationCg', true)

  const employerDetails = computed(() => ({
    'Entité ADH': model?.employeur?.etablissement?.denomination,
    Siret: model?.employeur?.etablissement?.siret?.valeur,
    IDCC: idcc,
    Email: model?.employeur?.contact?.email,
    'N° et Voie': model?.employeur?.etablissement?.adresse?.voie,
    Complément: model?.employeur?.etablissement?.adresse?.complement,
    'Code Postal': model?.employeur?.etablissement?.adresse?.codePostal,
    Ville: model?.employeur?.etablissement?.adresse?.commune,
  }))

  const achatMateriel = computed(() => {
    const achatMateriel = model?.prestation?.fraisAnnexes?.find((m) => m.nature === 'AchatMateriel')
    if (!achatMateriel) return null
    return achatMateriel
  })

  const prestationDetails = computed(() => ({
    'Prestataire': model?.prestation?.etablissement?.denomination,
    Siret: model?.prestation?.etablissement?.siret?.valeur,
    'Type de badge/carte': model?.sousDispositif != null ? SousDispositifLibelle[model?.sousDispositif] : '',
    "Nombre de badge/carte": achatMateriel?.value?.quantite,
    'Coût unitaire badge/carte' : `${formatNumber(achatMateriel?.value?.montant ?? 0, { decimal: 2, separateur: true })} €`
  }))

  const chiffrageDetails = computed(() => {
    const coutAchatMateriel = (Number(achatMateriel.value?.quantite) ?? 0) * (achatMateriel.value?.montant ?? 0)

    return {
      'Coût total': `${formatNumber(coutAchatMateriel, { decimal: 2, separateur: true })} €`
    }
  })


</script>

<style scoped lang="less">
  .synthese__container {
    width: 90%;
    align-self: center;
    margin: @spacing-20 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    gap: 20px;

    > div {
      width: calc(45% - 10px);
      border-radius: @border-radius-l;

      @media (max-width: @breakpoint-tablet) {
        width: 100%;
      }
    }

    @container (max-width: @breakpoint-mobile) {
      width: 100%;
    }
  }

  .element {
    &__header {
      display: flex;
      font-weight: bold;
      padding-bottom: @spacing-10;
      border-bottom: 1px solid @secondary-600;
    }

    &__row {
      flex: 1;
      display: flex;
      padding: @spacing-5 0;
      border-bottom: 1px solid #e0e0e0;
    }

    &__header,
    &__row {
      > span {
        flex: 1;
        height: 20px;
        padding: 0 @spacing-5;
        text-align: left;
      }
    }
  }
</style>
